import React, { useState, useEffect, Fragment } from 'react';
import {
  getHoverEffectValue,
  isItUndefined,
  isLinkAbsolute,
  isMobile,
  renderTextColor,
} from '../../util/DataUtil';
import { useRouter } from 'next/router';
import SmallLogoWall from './small-logo-wall';
import LargeLogoWall from './large-logo-wall';
import Image from 'next/image';
import Link from 'next/link';

const onMouseEnter = (item, setHover) => {
  setHover(item);
};

const onMouseLeave = (item, setHover) => {
  setHover(false);
};

const Partnership = (data) => {
  const router = useRouter();
  const [text, setText] = useState('');
  const [hover, setHover] = useState(false);
  const logoVariant = data?.children?.field_headline_variant_logo?.[0]?.value;
  const isH2ClassStyled = !logoVariant || logoVariant === '0';
  useEffect(() => {
    setText(isItUndefined(data?.children?.field_partnership_text));
  }, []);

  if (!data) {
    return;
  }

  const logos =
    data?.children?.field_partnership_logo?.partnership_logos_paragraph_type;
  let alignTitle = isItUndefined(data.children?.field_align_main_title);

  if (!logos) {
    return <></>;
  }

  const getAlignment = () => {
    if (alignTitle !== undefined) {
      return alignTitle === '1' ? 'center' : '';
    }
  };

  const getCursor = (item) => {
    return isItUndefined(item?.field_partnership_url) ? ' pointer' : '';
  };

  const getHoverEffect = (hoverEffect) => {
    if (hoverEffect === undefined) {
      return ' color';
    }

    return ' ' + getHoverEffectValue(hoverEffect);
  };

  const renderImage = (image) => {
    const mainLogo = image?.field_logo_image?.[0];
    const fallbackLogo = isItUndefined(image?.field_part, 'uri');

    if (mainLogo) {
      return (
        <div className="logo-wrapper">
          <div className="logo-shadow">
            <Image alt="logo-shadow" src={mainLogo} layout="fill" />
          </div>
          <div className="logo-actual">
            <Image alt="partner-logo" src={mainLogo} layout="fill" />
          </div>
        </div>
      );
    } else if (fallbackLogo) {
      return (
        <div className="logo-wrapper">
          <div className="logo-shadow">
            <img src={fallbackLogo} alt="logo-shadow" />
          </div>
          <div className="logo-actual">
            <img src={fallbackLogo} alt="partner-logo" />
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const renderLogos = () => {
    return logos.map((item, key) => {
      const url = item?.field_partnership_url?.[0]?.value;
      const isAbsolute = isLinkAbsolute(url);

      const className =
        'div-partnership-link logo' +
        getCursor(item) +
        getHoverEffect(
          isItUndefined(data?.children?.field_choose_your_hover_effect)
        );

      const style = {
        zIndex: hover.id === item.id ? 1 : 0,
      };

      const handleMouseEnter = () => onMouseEnter(item, setHover);
      const handleMouseLeave = () => onMouseLeave(item, setHover);

      return (
        <Link href={url} key={`partnership-${item.id || key}`} passHref>
          <a
            rel="noopener noreferrer"
            style={style}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            target={isAbsolute ? '_blank' : '_self'}
            className={className}
          >
            {renderImage(item)}
          </a>
        </Link>
      );

      // if (!url) {
      //   return (
      //     <div
      //       key={'partnership-key-' + key}
      //       className={className}
      //       style={style}
      //       onMouseEnter={handleMouseEnter}
      //       onMouseLeave={handleMouseLeave}
      //     >
      //       {renderImage(item)}
      //     </div>
      //   );
      // }
      //
      // if (isAbsolute) {
      //   return (
      //     <a
      //       key={'partnership-key-' + key}
      //       href={url}
      //       target="_blank"
      //       rel="noopener noreferrer"
      //     >
      //       {innerDiv}
      //     </a>
      //   );
      // }

      // Internal link, render <a> manually for right click support
      // return (
      //   <Link
      //     key={'partnership-key-' + key}
      //     href={url.startsWith('/') ? url : '/' + url}
      //     legacyBehavior
      //   >
      //     <a>{innerDiv}</a>
      //   </Link>
      // );
    });
  };

  {
    /*<img src={item.field_part ? item.field_part[0]?.uri : ""} alt={item.field_part ? item.field_part[0]?.alt : "partner-logo"} />*/
  }
  {
    /*<img src={'https://dlr-backend.getdeveloper.net/sites/default/files/2022-10/image%2013_0.png'} alt={item.field_part ? item.field_part[0]?.alt : "partner-logo"} />*/
  }
  {
    /*<img src={'https://dlr-backend.getdeveloper.net/sites/default/files/2023-01/googlecolor.png'} alt={item.field_part ? item.field_part[0]?.alt : "partner-logo"} />*/
  }

  const returnBackground = () => {
    if (!data?.children?.field_partnership_background) {
      return '';
    }

    if (data?.children?.field_partnership_background[0]?.value === '1') {
      return 'gray';
    } else {
      return 'white';
    }
  };

  const getWidth = () => {
    let viewportWidth;

    if (typeof window !== 'undefined') {
      viewportWidth = window.innerWidth;
    }

    return isMobile(viewportWidth);
  };

  return (
    <div id={'partnership'}>
      {Number(isItUndefined(data?.children?.field_choose_logo_wall_version)) ===
      0 ? (
        <SmallLogoWall
          data={data}
          text={text}
          renderLogos={renderLogos}
          returnBackground={returnBackground}
          getWidth={getWidth}
          getAlignment={getAlignment}
          isH2ClassStyled={isH2ClassStyled}
        />
      ) : (
        <LargeLogoWall
          data={data}
          text={text}
          renderLogos={renderLogos}
          returnBackground={returnBackground}
          getWidth={getWidth}
          getAlignment={getAlignment}
          isH2ClassStyled={isH2ClassStyled}
        />
      )}
    </div>
  );
};

export default Partnership;
